import React from "react";
import HeroTheme from "./HeroTheme";
import AcercaDe from "./AcercaDe"; // Asegurar que se llama correctamente


const Index = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow bg-white">
        {/* Secciones principales */}
        <HeroTheme />
        <AcercaDe />

      </main>
    </div>
  );
};

export default Index;
